module.exports = __webpack_public_path__ + "static/media/icn_map_pin_bus_late_lex_selected.422acc5a.svg";